import { CATEGORY_MAP } from "../utils/constants";
import ProfileAvatar from "./ProfileAvatar";
import styles from "../styles/theme";

export default function PersonDetailModal({
  person,
  people,
  onClose,
  onEdit,
  onDelete,
}) {
  const cat = CATEGORY_MAP[person.category];
  const parent = people.find((p) => p.id === person.parentId);
  const children = people.filter((p) => p.parentId === person.id);

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div
        style={{ ...styles.modal, maxWidth: 480 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            ...styles.modalHeader,
            borderBottom: `3px solid ${cat?.color || "#555"}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <ProfileAvatar
              person={person}
              size={48}
              fontSize={20}
              color={cat?.color}
            />
            <div>
              <h2 style={{ ...styles.modalTitle, marginBottom: 2 }}>
                {person.name}
              </h2>
              <div style={{ color: "#9a9a9e", fontSize: 14 }}>
                {person.relationship}
              </div>
            </div>
          </div>
          <button onClick={onClose} style={styles.modalClose}>
            ✕
          </button>
        </div>

        <div style={styles.modalBody}>
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Category</span>
            <span
              style={{ ...styles.personCardCategory, borderColor: cat?.color }}
            >
              {cat?.icon} {cat?.label}
            </span>
          </div>
          {person.meetingPlace && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Meeting Place</span>
              <span style={styles.detailValue}>📍 {person.meetingPlace}</span>
            </div>
          )}
          {person.jobDescription && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Job Description</span>
              <span style={styles.detailValue}>💼 {person.jobDescription}</span>
            </div>
          )}
          {person.phoneNumber && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Phone Number</span>
              <span style={styles.detailValue}>📞 {person.phoneNumber}</span>
            </div>
          )}
          {person.phoneNumberGiven && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Phone # Given</span>
              <span style={styles.detailValue}>
                {person.phoneNumberGiven === "primary_a"
                  ? "Primary (A)"
                  : "Secondary (M)"}
              </span>
            </div>
          )}
          {person.dateMet && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Date Met</span>
              <span style={styles.detailValue}>
                🤝{" "}
                {new Date(person.dateMet + "T00:00:00").toLocaleDateString(
                  "en-US",
                  { month: "long", day: "numeric", year: "numeric" },
                )}
              </span>
            </div>
          )}
          {person.birthdate && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Birthdate</span>
              <span style={styles.detailValue}>
                🎂{" "}
                {new Date(person.birthdate + "T00:00:00").toLocaleDateString(
                  "en-US",
                  { month: "long", day: "numeric", year: "numeric" },
                )}
              </span>
            </div>
          )}
          {person.significantOther && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Significant Other</span>
              <span style={styles.detailValue}>
                💕 {person.significantOther}
              </span>
            </div>
          )}
          {person.intimatePartner && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Intimate Partner</span>
              <span style={styles.detailValue}>
                💜 Yes
                {person.intimateStart || person.intimateEnd
                  ? ` · ${person.intimateStart ? new Date(person.intimateStart + "T00:00:00").toLocaleDateString("en-US", { month: "short", year: "numeric" }) : "?"} – ${person.intimateEnd ? new Date(person.intimateEnd + "T00:00:00").toLocaleDateString("en-US", { month: "short", year: "numeric" }) : "Present"}`
                  : ""}
              </span>
            </div>
          )}
          {person.nightsTogether && person.nightsTogether.length > 0 && (
            <div
              style={{
                ...styles.detailRow,
                flexDirection: "column",
                alignItems: "stretch",
                gap: 6,
              }}
            >
              <span style={styles.detailLabel}>
                Nights Together ({person.nightsTogether.length})
              </span>
              <div style={styles.nightsDetailList}>
                {[...person.nightsTogether]
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((n) => (
                    <div key={n.id} style={styles.nightsDetailItem}>
                      <span style={styles.nightsDetailDate}>
                        {new Date(n.date + "T00:00:00").toLocaleDateString(
                          "en-US",
                          { month: "short", day: "numeric", year: "numeric" },
                        )}
                      </span>
                      {n.label && (
                        <span style={styles.nightsDetailLabel}>{n.label}</span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}
          <div style={styles.detailRow}>
            <span style={styles.detailLabel}>Added</span>
            <span style={styles.detailValue}>
              📅{" "}
              {new Date(person.dateAdded).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </span>
          </div>
          {parent && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Linked to</span>
              <span style={styles.detailValue}>🔗 {parent.name}</span>
            </div>
          )}
          {children.length > 0 && (
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Connections</span>
              <span style={styles.detailValue}>
                {children.map((c) => c.name).join(", ")}
              </span>
            </div>
          )}
          {person.notes && (
            <div
              style={{ ...styles.detailRow, flexDirection: "column", gap: 6 }}
            >
              <span style={styles.detailLabel}>Notes</span>
              <div style={styles.notesBlock}>{person.notes}</div>
            </div>
          )}
        </div>

        <div style={styles.modalFooter}>
          <button
            onClick={() => {
              if (confirm(`Remove ${person.name}?`)) {
                onDelete(person.id);
                onClose();
              }
            }}
            style={{ ...styles.cancelBtn, color: "#e06060" }}
          >
            Delete
          </button>
          <button onClick={() => onEdit(person)} style={styles.saveBtn}>
            Edit
          </button>
        </div>
      </div>
    </div>
  );
}
